export default __webpack_public_path__ + "static/media/ilustrasi-1.1506d71b.svg";